interface ErrorMessageChartProps {
  error: Error | null
}

export default function ErrorMessageChart({ error }: ErrorMessageChartProps) {
  return <span role="alert">{__DEV__ && <pre>{error?.message}</pre>}</span>
}
